import React from "react";
import { useNavigate } from "react-router-dom";
import { UtensilsCrossed, Phone, Navigation } from "lucide-react";
import { ADDRESS } from "../../lib/images";

export const MobileActionBar = ({ settings }) => {
  const navigate = useNavigate();
  const phone = (settings?.phone || "").replace(/[^0-9+]/g, "");
  const hasPhone = phone.length >= 7;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${ADDRESS.mapsQuery}`;

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-hb-black/85 backdrop-blur-xl border-t border-hb-line grid grid-cols-3"
      data-testid="mobile-action-bar"
    >
      <button
        onClick={() => navigate("/menu")}
        className="flex flex-col items-center justify-center gap-1 py-3 text-hb-cream active:bg-hb-elevated transition-colors"
        data-testid="action-bar-menu"
      >
        <UtensilsCrossed size={19} className="text-hb-brass" />
        <span className="eyebrow text-[0.6rem]">Menu</span>
      </button>

      {hasPhone && (
        <a
          href={`tel:${phone}`}
          className="flex flex-col items-center justify-center gap-1 py-3 text-hb-cream active:bg-hb-elevated transition-colors border-x border-hb-line"
          data-testid="action-bar-call"
        >
          <Phone size={19} className="text-hb-brass" />
          <span className="eyebrow text-[0.6rem]">Call</span>
        </a>
      )}

      <a
        href={directions}
        target="_blank"
        rel="noreferrer"
        className={`flex flex-col items-center justify-center gap-1 py-3 text-hb-cream active:bg-hb-elevated transition-colors ${hasPhone ? "" : "col-span-2 border-l border-hb-line"}`}
        data-testid="action-bar-directions"
      >
        <Navigation size={19} className="text-hb-brass" />
        <span className="eyebrow text-[0.6rem]">Directions</span>
      </a>
    </div>
  );
};
